<template>
  <div style="padding: 0 20px;">
    <p>
      <strong>1.企业基础信息</strong>
    </p>
    <p>
      <strong>&nbsp;&nbsp;</strong>企业概况填写完成后，点击<span style="color:#9BBB59;">保存</span>按钮，才能编辑后续内容。
    </p>
    <p>
      <strong>2.其他信息</strong>
    </p>
    <p>
      &nbsp; 1）主要联系人中的<span style="color:#9BBB59;">业务联系人</span>，
      为必填项，其他选填，<span style="color:#9BBB59;">双击</span>单元格进行填写，完成后点击<span style="color:#9BBB59;">保存</span>
    </p>
    <p>
      &nbsp; 2）人力资源情况、企业基本状况、企业经营状况，根据实际情况填写，完成后点击<span style="color:#9BBB59;">保存<span style="color:#000000;"></span></span>
    </p>
    <p>
      &nbsp; 3）主要产品目录，点击<span style="color:#9BBB59;">新增</span><span style="color:#000000;">
      按钮添加数据，可以添加多条，完成之后点击<span style="color:#9BBB59;">保存</span>按钮即可，错填数据可以双击数据进行修改完成点击保存，
      不需要的数据可以选中点击<span style="color:#9BBB59;">删除</span>按钮<br />
            </span>
    </p>
    <p>
      <strong><span style="color:#9BBB59;"><span style="color:#000000;">3.附件上传</span></span></strong>
    </p>
    <p>
        <span style="color:#9BBB59;"><span style="color:#000000;">&nbsp; 点击<span style="color:#9BBB59;">上传文件</span>先择要上传的附件类型，
          <span style="color:#9BBB59;">营业执照</span>和<span style="color:#9BBB59;">质量体系认定书</span>为必须上传附件<br />
            </span></span>
    </p>
    <p>
      <strong><span style="color:#9BBB59;"><span style="color:#000000;">4.提交审核</span></span></strong>
    </p>
    <p>
        <span style="color:#9BBB59;"><span style="color:#000000;">&nbsp;确认所有信息无误后，点击
          <span style="color:#9BBB59;">提交</span>按钮<br />
            </span></span>
    </p>
    <p>
      <span style="color: rgb(155, 187, 89); font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <el-button icon="el-icon-download" type="success" @click="downloadfiles()">点击下载帮助手册</el-button>
    </p>
    <p>
      <span style="color:#000000;">补充说明：</span>
    </p>
    <p>
      <span style="color:#000000;">1.提交之后所有内容就无法进行再次编辑。</span>
    </p>
    <!-- <p>
      <span>2.下载视频版操作手册，约3分钟左右，请耐心等待。</span>
    </p> -->
    <el-dialog title="操作指南:" :visible.sync="fileFlag" :close-on-click-modal="false" :append-to-body="true" :close-on-press-escape="false" width="45%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="rowId" label="序号" align="center" width="60"></el-table-column>
        <el-table-column prop="originalName" label="文件链接" width="360">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDownload(scope.row)"> {{ scope.row.originalName }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="fileRemark" label="说明" width="180">
        </el-table-column>
      </el-table>
    </el-dialog>
    <div class="site-wrapper" :class="{ 'site-sidebar--fold': sidebarFold }" v-loading.fullscreen.lock="loading" element-loading-text="下载中"></div>
  </div>
</template>

<script>
import {getUrl} from '@/controller/sys'
  export default {
    components: {

    },
    computed: {
      documentClientHeight: {
        get() {
          return this.$store.state.common.documentClientHeight
        },
        set(val) {
          this.$store.commit('common/updateDocumentClientHeight', val)
        }
      },
      sidebarFold: {
        get() {
          return this.$store.state.common.sidebarFold
        }
      }
    },
    data() {
      return {
        fileFlag: false,
        loading: false,
        tableData: [
          {
              id: 319,
              url:'doc/SRM操作手册.zip',
              rowId: 1,
              originalName: 'SRM操作手册.zip',
              fileRemark: 'SRM操作手册'
          }
        ]
      }
    },
    mounted() {

    },
    methods: {
      
      downloadfiles() {
        this.fileFlag = true
      },

       handleDownload(row) {
        //  getUrl({
        //       'fileId': row.id
        //   }).then(data => {
        //       if (data && data.code === '00' && data.body) {
        //           this.download(data.body, row.originalName)
        //       } else {

        //       }
        //   })

        this.download(row.url, row.originalName)
      },

       getBlob(url, cb) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "blob";
              xhr.onload = function() {
                if (xhr.status === 200) {
                  cb(xhr.response);
                }
              };
              xhr.send();
            },
            saveAs(blob, filename) {
              if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
              } else {
                var link = document.createElement("a");
                var body = document.querySelector("body");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                // fix Firefox
                link.style.display = "none";
                body.appendChild(link);

                link.click();
                body.removeChild(link);

                window.URL.revokeObjectURL(link.href);
              }
            },
            download(url, filename) {
              const _this = this
              this.getBlob(url, function(blob) {
                _this.saveAs(blob, filename);
              });
            }

    }
  }
</script>

<style lang="scss" scoped>
  .el-drawer__header{
    margin-bottom: 0 !important;
  }
</style>
